$(document).ready(function () {

	let options = null;

	setIOPrBase();

	// loads all settings/variables for iopr functionality
	// determines chart provider and uses it
	function setIOPrBase() {

		// get base variables
		var $ioprWrapper = $('.iopr-data-wrapper');
		var $treeChartWrapper = $('.section-wrapper.tree-map');
		var $treeChartData = $treeChartWrapper.find('.chart-data');
		var $treeChartLoader = $treeChartWrapper.find('.chart-outer-loading-wrapper');
		var $treeTableWrapper = $treeChartWrapper.find('.table-wrapper .table-data');
	
		var $stackedAreaChartWrapper = $('.section-wrapper.stacked-area-chart');
		var $stackedAreaChartData = $stackedAreaChartWrapper.find('.chart-data');
		var $stackedAreaChartLoader = $stackedAreaChartWrapper.find('.chart-outer-loading-wrapper');
		var $stackedAreaPeriodFrom = $('#period-from-selector');
		var $stackedAreaPeriodTo = $('#period-to-selector');
		var $stackedAreaFilterForm = $('.filter-wrapper.stacked-area form');
		var $stackedAreaSubmitBtn = $stackedAreaFilterForm.find('button[type="submit"]');
	
		var $lng = $ioprWrapper.attr('data-lng');


		// set base options for iopr funcitonality
		// and set certain functions that will get used across modules

		options = {
			base: {
				api: '/iopr/iopr.php',
				lng: $lng,
				apiIncludeLng: () => {
					return `${options.base.api}?lng=${lng}`;
				}
			},
			html: {
				ioprWrapper: $ioprWrapper,
				tree: {
					chartWrapper: $treeChartWrapper,
					chartData: $treeChartData,
					chartLoader: $treeChartLoader,
					tableWrapper: $treeTableWrapper
				},
				stackedArea: {
					chartWrapper: $stackedAreaChartWrapper,
					chartData: $stackedAreaChartData,
					chartLoader: $stackedAreaChartLoader,
					periodFrom: $stackedAreaPeriodFrom,
					periodTo: $stackedAreaPeriodTo,
					filterForm: $stackedAreaFilterForm,
					filterSubmit: $stackedAreaSubmitBtn
				}
			},
			properties: {
				chartType: null,
				type: $ioprWrapper.attr('data-type'),
				cashFlow: $ioprWrapper.attr('data-cash-flow'),
				parent: null, // currently displayed parent in treemap
				excluded: [], // list of excluded field ids from table
				baseTravel: null,
				targetNode: null,
				useConfirm: null,
				setParent: (obj, type = 'google', travelObj = null) => {
					if (type == 'echart') {
						if (travelObj && !options.properties.baseTravel) {
							options.properties.baseTravel = travelObj;
							// {
							// 	type: 'treemapZoomToNode',
							// 	from: travelObj.from,
							// 	seriesId: travelObj.seriesId
							// };
						}
						// obj is targetNode
						options.properties.targetNode = obj;
						let _parent = null;
						if (!obj.dataIndex) {
							options.properties.targetNode = obj;
							_parent = {
								id: obj.dataIndex ? obj.data.id : null,
								label: obj.dataIndex ? obj.name : null
							};
						} else {
							const id = obj.hostTree.data._idList[obj.dataIndex];
							const name = obj.name;
							_parent = {
								id: id,
								name: name
							};
						}
						options.properties.parent = _parent;
					}
					if (type == 'google') {
						// set parent if we traveled or we havent reach leafnode so it doesnt have a parent
						const findIfChild = options.data.tree.currentData.find(x => x[1] && x[1].v == obj.v);
						if (findIfChild) {
							const _parent = {
								id: obj.v != '-1' ? obj.v : null,
								label: obj.f
							};
							options.properties.parent = _parent;
						}
					}
				},
				// set parent when table row is clicked
				// their demands!
				setParentFromTable: ($tr, type = 'google') => {
					if (type == 'google') {
						var id = $tr.attr('data-id');
						var description = $tr.find('.description span').text();

						const _parent = {
							id: id,
							description: description
						};
						options.properties.parent = _parent;
					} else {
						throw new Exception('Not yet implemented');
					}
				}
			},		
			charts: {
				stackedArea: {
					chart: null,
					options: null,
					generate: null,
					travelLevels: function(parentid) {
						if (options.charts.stackedArea.chart) {
							// only if chart is alredy generated
							options.charts.stackedArea.options.parentId = parentid;
							options.charts.stackedArea.generate();
						}
					},
					validateFilter: function() {
						
						if (!isValid()) {
							options.html.stackedArea.filterSubmit.prop('disabled', true);
						} else {
							options.html.stackedArea.filterSubmit.removeAttr('disabled');
						}
	
						function isValid() {
							// check if parent id exists else we cant draw
							if (!options.properties.parent) {
								return false;
							}
	
							var from = options.html.stackedArea.periodFrom.val();
							var to = options.html.stackedArea.periodTo.val();
							if (!from || !to) {
								return false;
							}
	
							if (parseInt(to, 10) < parseInt(from, 10)) {
								return false;
							}
	
							return true;
						}
					},
					resize: null
				},
				tree: {
					chart: null,
					properties: {},
					//options: require('./config/google/treemap/configuration')
					options: null,
					generate: null,
					generateEchart: null,
					resize: null,
				} 
			}, 
			elements: {
				tableModal: null
			},
			data: {
				tree: {
					baseData: null,
					baseGoogleData: null,
					currentData: null,
					currentGoogleData: null
				},
				stackedArea: {
					baseData: null,
					currentData: null,
				}
			},
			status: {
				tree: {
					processing: false
				},
				stackedArea: {
					processing: false
				},
				data: {
					processing: false
				}
			},
			methods: {
				isProcessing: () => {
					return options.status.stackedArea.processing || 
						options.status.tree.processing || options.status.data.processing;
				},
				triggerStartProcessing: (type) => {
					// type is either stackedArea or tree
					if (!options.status.stackedArea.processing && 
							!options.status.tree.processing && !options.status.data.processing) {
						var $processingSelectors = $('.toggle-select,.chart-manipulation-toggle');
						$processingSelectors.addClass('grayscale-important');
						$processingSelectors.each(function(index, item) {
							var $item = $(item);
							$item.attr('title', $item.attr('data-title-disabled'));
						});
					}
					options.status[type].processing = true;
				},
				triggerEndProcessing: (type) => {		
					options.status[type].processing = false;

					if (!options.status.stackedArea.processing && 
							!options.status.tree.processing && !options.status.data.processing) {
						var $processingSelectors = $('.toggle-select,.chart-manipulation-toggle');
						$processingSelectors.removeClass('grayscale-important');
						$processingSelectors.each(function(index, item) {
							var $item = $(item);
							$item.attr('title', $item.attr('data-title-enabled'));
						});
					}
				}
			}
		};

		// depending on which chart provider we use
		// we import method declarations

		const chartType = $ioprWrapper.attr('data-chart-type');
		options.properties.chartType = chartType;

		// check if to use dialog to remove/add nodes
		options.properties.useConfirm = options.html.tree.tableWrapper.hasClass('use-confirm');
		switch (chartType) {
			case 'google-charts':
				// load treemaps from the google api
				
				// tooltip function for chart
				const tooltipFunction = function (row, size, value) {

					const formattedValue = parseFloat(size).toLocaleString();

					return '<div style="background:infobackground;color:infotext;padding:1px;border:1px solid infotext;fontSize:14px;fontFamily:Roboto Slab;">' + 
								options.data.tree.currentGoogleData.getFormattedValue(row, 0) + ' <br> ' +
								formattedValue + ' €'+
							'</div>';
				};

				if($('.iopr-data-wrapper').attr('data-cash-flow') == 'outcome'){
					options.charts.tree.options = require('./config/google/treemap/configuration-outcome')(tooltipFunction);
				}else{
					
					options.charts.tree.options = require('./config/google/treemap/configuration-income')(tooltipFunction);
				}

				google.charts.load('current', {
					'packages': ['corechart', 'treemap'],
					'language': 'sl'
				});
				require('./treemap-chart-google')(options);
				require('./stacked-area-chart-google')(options);
			break;
			case 'e-charts':
				require('./treemap-chart-echart')(options);
				require('./stacked-area-chart-echart')(options);
			break;
		}
	
	}

	
	// table functionalities are independant to char provider
	require('./table-toggle-rows')(options);
	require('./table-stackedarea-selection')(options);
	require('./add-remove-nodes')(options);

	$(window).resize(function() {
		if (options.charts.stackedArea.chart) {
			options.charts.stackedArea.resize();
		}
		if (options.charts.tree.chart) {
			options.charts.tree.resize();
		}
	})


	function showStackedAreaChartWrapper(){
		$('.iopr-filter-submit.first').on('click', ()=>{
			$('.stacked-area-chart').fadeIn();
		});
		$('.iopr-filter-submit.second').on('click', ()=>{
			$('.sub-section.graf').fadeIn();
		});

		
	}
	showStackedAreaChartWrapper();

	
});
